<template>
  <div class="player-page">
    <!-- 顶部导航栏 -->
    <van-nav-bar class="nav-bar" :title="data.xuanfei_name">
      <template #left>
        <van-icon name="arrow-left" size="22" color="#fff" @click="onClickLeft()" />
      </template>
    </van-nav-bar>

    <!-- 隐藏的音频播放器 -->
    <audio
      ref="audioPlayer"
      :src="data.pvideo"
      @timeupdate="onTimeUpdate"
      @loadedmetadata="onLoadedMetadata"
      @ended="onEnded"
      @play="onPlaying"
      @pause="onPause"
    ></audio>

    <!-- 内容区域 -->
    <div class="player-content">
      <!-- 1. 歌曲封面（大圆形，居中） -->
      <div class="cover-wrapper">
        <div class="cover-circle">
          <img 
            v-if="data.img_url" 
            :src="data.img_url" 
            class="cover-img" 
            alt=""
          />
          <!-- 播放/暂停按钮（在封面中间） -->
          <div class="play-btn-mask" @click="togglePlay">
            <van-icon :name="isPlaying ? 'pause' : 'play'" size="36PX" color="#fff" />
          </div>
        </div>
      </div>

      <!-- 2. 歌曲标题 -->
      <div class="song-title">{{ data.xuanfei_name }}</div>

      <!-- 3. 歌手信息 + 关注 -->
      <div class="song-info-row">
        <div class="song-author">{{ data.bust }}</div>
        <div class="follow-btn">{{$t('auth.top50')}}</div>
      </div>

      <!-- 4. 操作按钮组 -->
      <div class="action-row">
        <div class="action-item">
          <van-icon name="music-o" size="22PX" color="#fff" />
          <span>{{$t('auth.top49')}}</span>
        </div>
        <div class="action-item">
          <van-icon name="down" size="22PX" color="#fff" />
          <span>{{$t('auth.top48')}}</span>
        </div>
        <div class="action-item">
          <van-icon name="share-o" size="22PX" color="#fff" />
          <span>{{$t('auth.top47')}}</span>
        </div>
        <div class="like-btn">
          <van-icon name="like-o" size="18PX" color="#fff" />
          <span>{{$t('auth.top46')}}</span>
        </div>
      </div>

      <!-- 5. 进度条（可拖动） -->
      <div class="progress-bar">
        <span class="time-start">{{ formatTime(currentTime) }}</span>
        <div class="progress-line" @click="onProgressClick">
          <div class="progress-active" :style="{ width: progressPercentage + '%' }"></div>
        </div>
        <span class="time-end">{{ formatTime(totalDuration) }}</span>
      </div>

      <!-- 6. 猜你喜欢模块 -->
      <div class="recommend-section">
        <div class="recommend-title">{{$t('auth.top52')}}</div>
        <div class="recommend-list">
          <div class="recommend-item" v-for="item in recommendData" :key="item.id" @click="toDetail(item.id)">
            <!-- 左侧小封面 -->
            <img 
              v-if="item.img_url" 
              :src="item.img_url" 
              class="recommend-thumb" 
              alt=""
            />
            <!-- 中间信息 -->
            <div class="recommend-info">
              <div class="recommend-name">{{ item.xuanfei_name }}</div>
              <div class="recommend-artist">{{ item.bust }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      kefu: '',
      currentTime: 0,
      totalDuration: 0,
      isPlaying: false,
      recommendData: []
    };
  },
  computed: {
    progressPercentage() {
      if (this.totalDuration === 0) return 0;
      return (this.currentTime / this.totalDuration) * 100;
    }
  },
  watch: {
    // 监听路由变化，当id改变时重新加载数据
    '$route.query.id': {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          this.loadData();
        }
      },
      immediate: false
    }
  },
  methods: {
    // 统一加载数据方法
    loadData() {
      // 重置播放状态
      this.currentTime = 0;
      this.totalDuration = 0;
      this.isPlaying = false;
      
      // 重新请求歌曲详情
      this.getxuanfeidata();
      // 重新请求猜你喜欢
      this.getRecommendData();
    },
    getxuanfeidata() {
      this.$http({
        method: 'get',
        url: 'xuanfeidata',
        data: { id: this.$route.query.id }
      }).then(res => {
        this.data = res.data;
        const lanng = this.$t("auth.lang");
        const parts = this.data.flag.split('|');
        lanng == 'zh' ? this.data.flag = parts[0] : lanng == 'en' ? this.data.flag = parts[1] : lanng == 'ja' ? this.data.flag = parts[2] : this.data.flag = parts[3];
        this.data.flagArray = this.data.flag.split('，');
        console.log(this.data, 998);
        
        this.$nextTick(() => {
          this.autoPlay();
        });
      });
    },
    // 获取猜你喜欢数据
    getRecommendData() {
      this.$http({
        method: "get",
        url: "xuanfeilist2",
        data: { page: 1, limit: 10 }
      }).then((res) => {
        this.recommendData = res.data;
        const lanng = localStorage.getItem("lang") || "zh";
        this.recommendData.forEach((item) => {
          if (item.flag) {
            const parts = item.flag.split("|");
            lanng == "zh"
              ? (item.flag = parts[0])
              : lanng == "en"
              ? (item.flag = parts[1])
              : lanng == "ja"
              ? (item.flag = parts[2])
              : (item.flag = parts[3]);
          }
        });
      });
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.kefu = res.data.kefu;
      });
    },
    onClickLeft() {
      this.$router.push({ path: '/Nanai' });
    },
    autoPlay() {
      const audio = this.$refs.audioPlayer;
      if (audio) {
        audio.play().catch(err => {
          console.log('自动播放失败:', err);
        });
      }
    },
    togglePlay() {
      const audio = this.$refs.audioPlayer;
      if (!audio) return;
      if (audio.paused) {
        audio.play();
      } else {
        audio.pause();
      }
    },
    onTimeUpdate() {
      const audio = this.$refs.audioPlayer;
      if (audio) {
        this.currentTime = audio.currentTime;
      }
    },
    onLoadedMetadata() {
      const audio = this.$refs.audioPlayer;
      if (audio) {
        this.totalDuration = audio.duration;
        this.autoPlay();
      }
    },
    onEnded() {
      this.currentTime = 0;
      this.isPlaying = false;
    },
    onPlaying() {
      this.isPlaying = true;
    },
    onPause() {
      this.isPlaying = false;
    },
    onProgressClick(event) {
      const audio = this.$refs.audioPlayer;
      if (!audio) return;
      const rect = event.currentTarget.getBoundingClientRect();
      const clickX = event.clientX - rect.left;
      const percentage = clickX / rect.width;
      audio.currentTime = percentage * audio.duration;
    },
    formatTime(seconds) {
      if (!seconds) return '00:00';
      const min = Math.floor(seconds / 60);
      const sec = Math.floor(seconds % 60);
      return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
    },
    // 点击猜你喜欢歌曲
    toDetail(id) {
      // 跳转到当前页面并带上新的id
      this.$router.push({ path: '/detail', query: { id: id } });
    }
  },
  created() {
    this.loadData();
    this.getBasicConfig();
  }
};
</script>

<style scoped lang="less">
.player-page {
  height: 100VH;
  background: linear-gradient(180deg, #1a3a40 0%, #0f2a30 50%, #0a1f25 100%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 顶部导航栏 */
.nav-bar {
  background: transparent !important;
  height: 50PX;
  flex-shrink: 0;
  :deep(.van-nav-bar__title) {
    color: #fff !important;
    font-size: 18PX;
    font-weight: 600;
  }
  :deep(.van-icon) {
    color: #fff;
    font-size: 22PX;
  }
}

/* 内容区域（可滚动） */
.player-content {
  flex: 1;
  padding: 0 20PX 30PX;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 1. 歌曲封面（大圆形，居中） */
.cover-wrapper {
  margin-top: 20PX;
  width: 240PX;
  height: 240PX;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 8PX 30PX rgba(0, 0, 0, 0.5);
  position: relative;
  flex-shrink: 0;
}

.cover-circle {
  width: 100%;
  height: 100%;
  position: relative;
}

.cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

/* 播放/暂停按钮 */
.play-btn-mask {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 56PX;
  height: 56PX;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2PX solid rgba(255, 255, 255, 0.3);
}

/* 2. 歌曲标题（居中） */
.song-title {
  margin-top: 25PX;
  font-size: 22PX;
  font-weight: 700;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}

/* 3. 歌手信息 + 关注 */
.song-info-row {
  margin-top: 12PX;
  display: flex;
  align-items: center;
  gap: 12PX;
}

.song-author {
  font-size: 14PX;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.follow-btn {
  font-size: 12PX;
  color: #fff;
  padding: 3PX 12PX;
  border-radius: 20PX;
  background: rgba(255, 255, 255, 0.2);
  cursor: pointer;
}

/* 4. 操作按钮组 */
.action-row {
  margin-top: 25PX;
  width: 100%;
  max-width: 320PX;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5PX;
  cursor: pointer;
  flex: 1;
  color: rgba(255, 255, 255, 0.8);
}

.action-item span {
  font-size: 12PX;
  color: rgba(255, 255, 255, 0.8);
}

/* 喜欢按钮（独立样式） */
.like-btn {
  display: flex;
  align-items: center;
  gap: 5PX;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20PX;
  padding: 8PX 16PX;
  cursor: pointer;
  color: #fff;
}

.like-btn span {
  font-size: 13PX;
  color: #fff;
}

/* 5. 进度条 */
.progress-bar {
  margin-top: 25PX;
  width: 100%;
  max-width: 320PX;
  display: flex;
  align-items: center;
  gap: 10PX;
}

.time-start {
  font-size: 12PX;
  color: rgba(255, 255, 255, 0.6);
}

.progress-line {
  flex: 1;
  height: 3PX;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2PX;
  position: relative;
  cursor: pointer;
}

.progress-active {
  height: 100%;
  background: #fff;
  border-radius: 2PX;
  transition: width 0.1s;
}

.time-end {
  font-size: 12PX;
  color: rgba(255, 255, 255, 0.6);
}

/* ===== 6. 猜你喜欢模块 ===== */
.recommend-section {
  width: 100%;
  max-width: 320PX;
  margin-top: 30PX;
}

.recommend-title {
  font-size: 18PX;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15PX;
}

.recommend-list {
  display: flex;
  flex-direction: column;
}

.recommend-item {
  display: flex;
  align-items: center;
  padding: 10PX 0;
  cursor: pointer;
}

.recommend-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8PX;
}

.recommend-thumb {
  width: 50PX;
  height: 50PX;
  border-radius: 8PX;
  object-fit: cover;
  flex-shrink: 0;
}

.recommend-info {
  flex: 1;
  margin-left: 12PX;
  overflow: hidden;
}

.recommend-name {
  font-size: 16PX;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4PX;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.recommend-artist {
  font-size: 13PX;
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .van-nav-bar__title {
  color: #fff !important;
  font-size: 18PX;
  font-weight: 600;
  text-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.8);
}
::v-deep .van-nav-bar__text {
  color: #fff !important;
}
::v-deep .van-icon{
  font-size: 20PX;
}
::v-deep .van-field__control{
  line-height: 18PX;height: 18PX;font-size: 14PX;
}
</style>